/** Abas do editor do curso (CA-03), fora do componente pelo mesmo motivo de `cadastros/abas.ts`. */
export const ABAS_DO_CURSO = ['conteudo', 'dados', 'acesso', 'alunos'] as const;
export type AbaDoCurso = (typeof ABAS_DO_CURSO)[number];
